export default {
  methods: {

    $confirm_delete_prompt(
      type,
      {
        title = null,
        additionalText = '',
        askForConfirmation = false
      } = {}
    ) {

      let confirm_text = '';
      let prompt = () => {};

      if ( askForConfirmation ) {

        prompt = this.$prompt;
        confirm_text =
          `This will permanently delete the ${type}` +
          ( title ? ` "${title}". ` : '. ' ) + additionalText +
          `Please confirm this action by typing "CONFIRM" into the input box.`

      } else {

        prompt = this.$confirm;
        confirm_text =
          `This will permanently delete the ${type}` +
          ( title ? ` "${title}". ` : '. ' ) + additionalText +
          `Continue?`
      }

      return prompt(
        confirm_text,
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
          closeOnClickModal: false,
      }).then((result) => {
        if ( askForConfirmation && result.value.toUpperCase() !== 'CONFIRM' ) {
          throw new Error('invalid-confirmation')
        }
        return {
          notify: () => {
            this.$notify({
              type: 'success',
              message: 'Deleted ' + type + ' sucessfully.'
            });
          }
        }
      }).catch((error) => {
        if ( error.message === 'invalid-confirmation' ) {
          this.$notify({
            type: 'info',
            message: 'Delete canceled, input was not "CONFIRM".'
          });
        } else {
          this.$notify({
            type: 'info',
            message: 'Delete canceled.'
          });
        }
        throw new Error('close')
      });
    },
  }
}
